import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/error-404.png")